import newspaperPdf from "@/http/requests/newspaperPdf"

export default {
  fetch({ commit }, queryData) {
    return new Promise((resolve, reject) => {
      newspaperPdf.fetch(queryData).then(response => {
        commit('SET_NEWSPAPER_PDFS', response.data.data.newspaperPdfs)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  add({ commit }, data) {
    return new Promise((resolve, reject) => {
      newspaperPdf.add(data).then(response => {
        commit('ADD_NEWSPAPER_PDF', response.data.data.createNewspaperPdf)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  delete({ commit }, newspaperPdfId) {
    return new Promise((resolve, reject) => {
      newspaperPdf.delete(newspaperPdfId).then(response => {
        commit('DELETE_NEWSPAPER_PDF', newspaperPdfId)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  infos({ commit }, newspaperPdfId) {
    return new Promise((resolve, reject) => {
      newspaperPdf.infos(newspaperPdfId).then(response => {
        commit('SET_NEWSPAPER_PDF_INFOS', response.data.data.newspaperPdfInfos)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  }
}
